module.exports = __webpack_public_path__ + "static/media/replyMessageCloseIcon.97070b77.svg";